import { CommodityConditionRequest } from 'store/commodity-conditions-center/commodityCondition';
import { CommodityConditionFormValues } from './toCommodityConditionFormValues';

const toCommodityConditionRequest = (values: CommodityConditionFormValues): CommodityConditionRequest => ({
    commodityCode: values.commodityCode.trim(),
    taricCode: values.taricCode.trim(),
    countryOrigin: values.countryOrigin.trim().toUpperCase(),
    conditionCodes: values.conditionCodes.map((code) => code.trim().toUpperCase()).filter(Boolean),
});

export default toCommodityConditionRequest;
